export function getUserTraits() {
  if (!window.analytics || !window.analytics.user || !window.analytics.user().traits) {
    return {};
  }
  const userTraits = (window.analytics.user().traits() as any) || {};
  return Object.keys(userTraits).reduce(
    (acc, trait) => {
      const key = `trait_${trait}`;
      acc[key] = userTraits[trait];
      return acc;
    },
    {} as Record<string, any>
  );
}
